/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Plugin, Plugin$inboundSchema } from "./plugin.js";

export type ListPluginsResult = {
  /**
   * The plugins in the organization.
   */
  plugins: Array<Plugin>;
};

/** @internal */
export const ListPluginsResult$inboundSchema: z.ZodMiniType<
  ListPluginsResult,
  unknown
> = z.object({
  plugins: z.array(Plugin$inboundSchema),
});

export function listPluginsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListPluginsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListPluginsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListPluginsResult' from JSON`,
  );
}
